// extracted by mini-css-extract-plugin
export default {"label":"PhoneInput_label__ACl2S","wrapper":"PhoneInput_wrapper__0bK9c"};